import React from "react";
import { motion, Variants } from "framer-motion";

// During prerendering (puppeteer sets navigator.webdriver) animations must be
// disabled so the static HTML snapshot is never captured at opacity: 0.
const isPrerender =
  typeof navigator !== "undefined" && navigator.webdriver === true;

type AnimationVariant = "fadeUp" | "fade" | "stagger";

const variantMap: Record<AnimationVariant, Variants> = {
  fadeUp: {
    hidden: { opacity: 0, y: 28 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  },
  fade: {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.7, ease: "easeOut" } },
  },
  stagger: {
    hidden: {},
    visible: { transition: { staggerChildren: 0.12 } },
  },
};

export const staggerChild: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55, ease: "easeOut" } },
};

interface AnimatedInViewProps {
  variant?: AnimationVariant;
  delay?: number;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const AnimatedInView: React.FC<AnimatedInViewProps> = ({
  variant = "fadeUp",
  delay = 0,
  children,
  style,
}) => (
  <motion.div
    initial={isPrerender ? false : "hidden"}
    whileInView="visible"
    viewport={{ once: true, margin: "-60px" }}
    variants={variantMap[variant]}
    transition={delay ? { delay } : undefined}
    style={style}
  >
    {children}
  </motion.div>
);

export default AnimatedInView;
